<template>
  <div class="height-100" style="background-color: #F8F8F8;">
    <!-- <div class="t-a-c bgc-white head" style="font-size: 1.1rem; font-weight: 600;color: black;">分类</div> -->
    <div class="fist">
      <div class="left-nav " ref="leftscoll">
        <van-sidebar v-model="activeKey">
          <van-sidebar-item
            v-for="(item, index) in category"
            :key="index"
            :title="item.name"
            @click="onSidebarSelect(index)"
          />
        </van-sidebar>
      </div>
      <div class="class-tabs" v-if="dataList && dataList.length">
        <!-- <div class="headtitle"> {{ active }}</div> -->
        <!-- <van-card class="cardsty" :price="item1.present_price" v-for="(item1, index1) in dataList" :key="index1"
            :origin-price="item1.orl_price" @click="goodOne(item1.id)" /> -->
        <div style=" border-radius: 0.6rem; padding: 1rem 0; ">
          <div v-for="(item1, index1) in tempList" :key="index1" class="goodline">
            <div style="display: inline; " v-for="(item2, index2) in item1" :key="index2" class="cardsty"
              @click="goodOne(index1, index2)">
              <div class="boxOne">
                <van-image lazy-load fit="contain" class="goodImg" :src="item2.icon" />
              </div>
              <div class="boxTwo">
                <div class="goodtitle">{{ item2.name }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- 底部 -->
    <!-- 底部 -->
    <AllNav></AllNav>
  </div>
</template>

<script>
import AllNav from "../../components/footnav/AllNav.vue";
import { navigateToGoodsList } from "@/utils/categoryNav";

/** sessionStorage 键：缓存当前选中的一级分类，用于整页返回、外链返回后恢复位置（路由无 query 时读取） */
const CLASSIFICATION_STATE_KEY = "ecms_classification_state";
export default {
  name: "Classification",
  props: {},
  data() {
    return {
      // 一级标题
      activeKey: 0,
      // 二级标题
      active: null,
      category: [

      ],
      level2: [

      ],
      tempList: [],
      //页面商品数据
      dataList: [],
      indexName: null,
      entorcode: '',
      cityCode: '',
      upgradeFlag: '',
      bathId: '',
    };
  },
  components: { AllNav },
  methods: {
    // 分类一二级获取(一次性获取)
    getData() {
      this.$api
        .selectCategoryWithChildren(this.bathId, this.upgradeFlag, this.cityCode, "CLASSIFICATION")
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.category = res.data.map(item => ({
              id: item.id,
              name: item.name,
              icon: item.icon,
              categoryScene: item.categoryScene,
              navRoute: item.navRoute,
              children: item.children,
            }));
            let selectIndex = typeof this.activeKey === "number" ? this.activeKey : 0;
            if (this.indexName) {
              let nameMatched = false;
              this.category.forEach((element, index) => {
                if (this.indexName == element.name) {
                  selectIndex = index;
                  nameMatched = true;
                }
              });
              if (!nameMatched) {
                selectIndex = 0;
              }
            }
            selectIndex = Math.max(0, Math.min(selectIndex, this.category.length - 1));
            this.$nextTick(() => {
              this.initSidebarHighlight(selectIndex);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /** 初始化高亮并加载右侧二级 */
    initSidebarHighlight(index) {
      this.activeKey = index;
      const row = this.category[index];
      if (!row) {
        return;
      }
      this.active = row.name;
      this.onClick(row.id);
      this.$nextTick(() => {
        this.scrollLeftNavToActive();
      });
    },
    /** keep-alive 返回时同步右侧二级网格 */
    syncRightPanel() {
      const row = this.category[this.activeKey];
      if (!row) {
        return;
      }
      this.active = row.name;
      this.onClick(row.id);
    },

    // 分类页面数据(使用本地children)
    onClick(val) {
      this.tempList.length = 0
      // 从本地category中查找children
      const currentCategory = this.category.find(c => c.id === val);
      if (currentCategory && currentCategory.children && currentCategory.children.length > 0) {
        this.dataList = currentCategory.children;
        this.tempList = this.listTemp();
      }
    },
    /** 用户点击左侧一级：展示右侧二级 */
    onSidebarSelect(index) {
      const row = this.category[index];
      if (!row) {
        return;
      }
      this.activeKey = index;
      this.active = row.name;
      this.onClick(row.id);
      this.persistClassificationState(index);
      this.$nextTick(() => {
        this.scrollLeftNavToActive();
      });
    },

    /**
     * 把当前一级分类选中状态写入 sessionStorage。
     * 在切换分类、跳转商品列表、跳转三方 H5 前调用，便于返回分类页时在没有路由参数的情况下仍能还原 activeKey / 名称。
     * @param {number|null|undefined} index 一级下标；不传则使用当前的 this.activeKey
     */
    persistClassificationState(index) {
      try {
        const i = index != null ? index : this.activeKey;
        const row = this.category[i];
        sessionStorage.setItem(
          CLASSIFICATION_STATE_KEY,
          JSON.stringify({
            activeKey: i,
            indexName: row ? row.name : "",
          })
        );
      } catch (e) {
        /* ignore */
      }
    },

    /**
     * 读取上次在分类页缓存的一级选中信息（activeKey、indexName）。
     * @returns {{ activeKey?: number, indexName?: string }|null} 解析失败或无数据时返回 null
     */
    readClassificationStateFromStorage() {
      try {
        const raw = sessionStorage.getItem(CLASSIFICATION_STATE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },

    /**
     * 将当前选中的一级分类（.van-sidebar-item--select）滚入左侧列表可视区域，并保留上下边距。
     * 做法：比较左侧滚动容器与选中项的 getBoundingClientRect，若超出可视范围则增量修正 scrollTop。
     * 不使用 scrollIntoView({ block: 'nearest' })：在底栏 fixed 时容易把项贴在滚动区最底部，仍会被 Tab 挡住。
     */
    scrollLeftNavToActive() {
      this.$nextTick(() => {
        const wrap = this.$refs.leftscoll;
        if (!wrap) return;
        const activeItem = wrap.querySelector(".van-sidebar-item--select");
        if (!activeItem) return;
        const margin = 12;
        const w = wrap.getBoundingClientRect();
        const r = activeItem.getBoundingClientRect();
        let delta = 0;
        if (r.top < w.top + margin) {
          delta = r.top - w.top - margin;
        } else if (r.bottom > w.bottom - margin) {
          delta = r.bottom - w.bottom + margin;
        }
        if (delta !== 0) {
          wrap.scrollTop += delta;
        }
      });
    },
    goodOne(index1, index2) {
      const parent = this.category[this.activeKey];
      const child = this.tempList[index1] && this.tempList[index1][index2];
      if (!parent || !child) {
        return;
      }
      this.persistClassificationState(this.activeKey);
      navigateToGoodsList(this, {
        navLevel: 2,
        id: child.id,
        parentId: parent.id,
        parentName: parent.name,
        name: child.name,
      });
    },
    listTemp() {
      let index = 0
      const count = 3
      const arrTemp = []
      const experts = this.dataList
      for (let i = 0; i < this.dataList.length; i++) {
        index = parseInt(i / count)
        if (arrTemp.length <= index) {
          arrTemp.push([])
        }
        arrTemp[index].push(experts[i])
      }
      return arrTemp
    },
    /**
     * 进入/回到分类页时初始化：从路由 query 优先读取 activeKey、indexName；无 query 时再读 sessionStorage；
     * 然后拉取分类树并在 getData 回调里按上述结果选中对应一级分类。
     */
    initView() {
      this.entorcode = localStorage.getItem('entrCode')
      const qk = this.$route.query.activeKey;
      const qn = this.$route.query.indexName;
      const saved = this.readClassificationStateFromStorage();
      if (qk !== undefined && qk !== null && qk !== "") {
        this.activeKey = parseInt(String(qk), 10);
      } else if (saved && saved.activeKey != null && !Number.isNaN(Number(saved.activeKey))) {
        this.activeKey = parseInt(String(saved.activeKey), 10);
      } else {
        this.activeKey = 0;
      }
      if (qn !== undefined && qn !== null && qn !== "") {
        this.indexName = qn;
      } else if (saved && saved.indexName) {
        this.indexName = saved.indexName;
      } else {
        this.indexName = null;
      }
      this.upgradeFlag = localStorage.getItem("upgradeFlag");
      this.bathId = localStorage.getItem("bathId");
      this.cityCode = localStorage.getItem("cityCode");
      this.getData();
      this.listTemp();
    }
  },
  mounted() {

  },
  /** keep-alive 再次激活：同步右侧二级并校正左侧滚动 */
  activated() {
    this.$nextTick(() => {
      if (this.category.length > 0) {
        this.syncRightPanel();
      }
      this.scrollLeftNavToActive();
    });
  },
  beforeRouteEnter(to, from, next) {
    to.meta.keepAlive = true
    // 非商品列表进入：整页或从其它页进来，需要重新 init（含读缓存、拉分类）
    if (from.path !== "/GoodsList") {
      next((vm) => {
        vm.$nextTick(() => {
          vm.initView()
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0
        })
      });
    } else {
      // 从商品列表返回：组件实例与数据由 keep-alive 保留，只把左侧一级滚到当前选中项附近
      next((vm) => {
        vm.$nextTick(() => {
          vm.scrollLeftNavToActive();
        });
      });
    }
  },
  watch: {},
};
</script>

<style lang='scss' scoped>
/* 底部 Tab 为 fixed，主区域需减去 Tab 高度与安全区，避免左侧滚动可视区域与底栏重叠导致最后一项被挡 */
.fist {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  height: calc(100vh - 4rem - env(safe-area-inset-bottom, 0px));
}

.cardsty {
  width: 30%;
  text-align: center;
  background: white;
  padding: 1%;
  overflow: hidden;
  margin: 1px;
  display: flex;
}

.boxOne {
  height: 80%;
  width: 100%;
}

.boxTwo {
  height: 20%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  // margin-top: 0.125rem;
}

.goodImg {
  height: 75%;
  width: 75%;
  margin-top: 0.5rem;
  // height: 23.6vw;
  // width: 20.333vw;
}

.headtitle {
  width: 100%;
  background-color: #f8f8f8;
  color: black;
  padding-top: 1rem;
  font-size: 1rem;
  padding-bottom: 1rem;
}

.goodtitle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  height: 100%;
  text-align: center;
  // margin-left: 14px;
  font-size: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.goodline {
  display: flex;
  overflow: hidden;
  width: 100%;
}

.class-tabs {
  flex: 1;
  margin-left: 1rem;
  margin-right: 0.5rem;
  overflow: scroll;
  /* margin-top: 3rem; */
  margin-bottom: 3rem;
}

/* 勿与右侧一同 stretch 撑满高度，否则 sidebar 内容不够高时会在底部出现大块空白 */
.left-nav {
  align-self: flex-start;
  max-height: 100%;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* margin-top: 3rem; */
  /* border-right: 1px solid rgb(226, 223, 223); */
  padding-bottom: 0.75rem;
}

.head {
  position: fixed;
  width: 100%;
  height: 2rem;
  z-index: 999;
  overflow: hidden;
  padding: 0.5rem;
}

::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  background-color: none;
}

::-webkit-scrollbar-thumb {
  background-color: none;
}

::-webkit-scrollbar-thumb:hover {
  background-color: none;
}

::-webkit-scrollbar-thumb:active {
  background-color: none;
}

.van-sidebar {
  width: 6.5rem;

  .van-sidebar-item {
    background-color: white;
    color: #403d3d;
    font-size: 0.875rem;
    width: 6.5rem;
    line-height: 1.2rem;
    text-align: center;
  }

  .van-sidebar-item--select::before {
    position: absolute;
    background-color: #d33b2e;
    height: 2.5rem;
    right: inherit;
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }

  .van-sidebar-item--select,
  .van-sidebar-item--select:active {
    background-color: #f8f8f8;

    color: #d33b2e;
  }
}
</style>